/** Portable capability identity for manifests and browser consumers. */
export const relationshipsImportCapability = 'relationships.import-reconciliation.v1';
//# sourceMappingURL=relationships-import-capability.contract.js.map